export default __webpack_public_path__ + "static/media/loading-animated.2b4c1b98.svg";